import dynamic from 'next/dynamic';
import React, { FC, ReactNode } from 'react';

const MediaQuery = dynamic(() => import('react-responsive'), {
  ssr: false,
});

const MediumScreen: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <MediaQuery minWidth={1024} maxWidth={1439}>
      {children}
    </MediaQuery>
  );
};

export default MediumScreen;
